import React from 'react';

export default function Resume() {
  return (
    <div>
        <section className="banner_section_padding">
            <div className="md_wrapper">
                <h1>I build platforms that drive revenue.</h1>
                <h4>I am a Full Stack Engineer who speaks the language of business.
                     While most developers stop at "it works," I focus on "it scales."</h4>
                <h5>"My background spans building custom e-commerce engines from scratch using Next.js 
                    and Node.js to architecting enterprise-grade themes on HubSpot CMS. Whether you need 
                    a complex web app or a high-converting marketing site, I write clean, modular code 
                    that loads fast."</h5>
                <a
                href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk"
                download
                className="cta_button"
                >
                Download resume as PDF
                </a>
            </div>
        </section>
        <section className="sec_sec section_padding">
            <div className="md_wrapper">
                <div className="exp">
                    <h3 className="text-xl font-semibold mb-4">Experience</h3>
                    <div className="mb-6">
                    <h4 className="font-bold">Full Stack Engineer (Next.js & MERN) / EmpKhet Services Private Limited / Remote </h4>
                    <p className="text-sm text-gray-500">July 2025 – Present</p>
                    <p>Leading the end-to-end engineering of a Direct-to-Consumer (DTC) organic food platform, focusing on speed and conversion.</p>
                    <ul>
                        <li><strong>Architecture & Performance:</strong> Built a high-performance e-commerce architecture
                         using Next.js (SSR), achieving a 98/100 Google PageSpeed score and reducing Time-to-Interactive 
                         (TTI) by 40% compared to standard SPAs.</li>
                        <li><strong>Backend Engineering:</strong> Developed a scalable REST API using Node.js and Express, 
                        handling secure user authentication (JWT), product inventory management, and order processing.</li>
                        <li><strong>Database Design:</strong> Designed optimized MongoDB schemas to manage complex product
                         variants and customer data, ensuring sub-100ms query responses.</li>
                        <li><strong>Conversion Optimization: </strong> Integrated custom cart functionality and secure
                         payment gateways, resulting in a streamlined checkout flow and reduced cart abandonment.</li>
                    </ul>
                    <h4 className="font-bold">HubSpot Developer & Technical Consultant / Freelance / Self-Employed / Remote</h4>
                    <p className="text-sm text-gray-500">Jan 2024 – Present </p>
                    <p>Delivering enterprise-grade HubSpot solutions for global clients, focusing on scalability and editability.</p>
                    <ul>
                        <li><strong>Custom Theme Development:</strong> Developed 10+ custom HubSpot themes from scratch using 
                        HubL and HTML5, ensuring 100% drag-and-drop flexibility for non-technical marketing teams.</li>
                        <li><strong>Advanced Module Creation:</strong> Engineered complex, reusable modules (calculators,
                         dynamic filtering, multi-step forms) that extended native HubSpot functionality to streamline 
                         content updates.</li>
                        <li><strong>Performance Optimization:</strong> Audited client sites and implemented code-splitting
                         and asset optimization, increasing average session duration by 20% through improved Core Web Vitals.</li>
                        <li><strong>Design to Code: </strong>Translated high-fidelity Figma designs into pixel-perfect, 
                        responsive HubSpot templates with cross-browser compatibility.</li>
                    </ul>
                    </div>
                    <div>
                    <h4 className="font-bold">Front-End Developer / Palmspire Technologies (iOSYS Software India Pvt. Ltd) / Bijnor, India</h4>
                    <p className="text-sm text-gray-500">2022 — 2024</p>
                    <ul>
                        <li>Created over 30+ responsive website themes using HTML, CSS, and JavaScript, achieving a 25% improvement 
                            in load times and mobile usability.</li>
                        <li>Conducted technical SEO audits and implemented fixes like schema, meta tags, and speed optimizations, 
                            leading to a 20% increase in organic traffic.</li>
                        <li>Collaborated with UI/UX designers and marketing teams to build brand-aligned web assets, enhancing lead
                             generation effectiveness.</li>
                    </ul>
                    </div>
                </div>

                <hr className="mt-40 mb-40"></hr>
                <div className="core mt-20">
                    <h3 className="text-xl font-semibold mb-4">Frontend Engineering</h3>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Next.js, React.js, TypeScript, TypeScript, Tailwind CSS, JavaScript (ES6+), HTML5/CSS3</li>
                    </ul>
                </div>

                <div className="hard">
                    <h3 className="text-xl font-semibold mb-4">Backend & Database</h3>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Node.js, Express.js, MongoDB, RESTful APIs, JWT Authentication, Server-Side Rendering (SSR)</li>
                    </ul>
                </div>

                <div className="soft">
                    <h3 className="text-xl font-semibold mb-4">HubSpot & CMS</h3>
                    <ul className="list-disc list-inside space-y-2">
                    <li>HubL, Custom Theme Development, HubSpot CRM API, Drag-and-Drop Modules, Pixel-Perfect Figma to HubSpot</li>
                    </ul>
                </div>

                <div className="int">
                    <h3 className="text-xl font-semibold mb-4">Tools & Performance</h3>
                    <ul className="list-disc list-inside space-y-2">
                    <li>Git/GitHub, Figma (UI Design, Google, Core Web Vitals Optimization, Postman</li>
                    </ul>
                </div>
            </div>
        </section>
        <section className="cta_section section_padding bg_dark all_text_white align_center">
            <div className="md_wrapper">
                <h2>Like what you see?</h2>
                <p>Explore more of my work or download my resume to get in touch.</p>
                <div className="buttons_container">
                <a href="/projects" className="cta_button White">
                    Explore more
                </a>
                <a href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk" className="cta_button white border">
                    Download resume
                </a>
                </div>
            </div>
      </section>
    </div>
  );
}
